"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadTransferRates = void 0;
const dayjs = require("dayjs");
const loadTransferRates = async (supabase, outbound_from, outbound_to, inbound_from, inbound_to, type, date, vehicle_id) => {
    let inbound_rate;
    const { data: outbound_rate } = await supabase.rpc("get_transfer_rates", {
        from_destination: outbound_from,
        to_destination: outbound_to,
        booking_date: dayjs(date).format("YYYY-MM-DD"),
    });
    if (type === "CUSTOM") {
        const { data: inbound } = await supabase.rpc("get_transfer_rates", {
            from_destination: inbound_from,
            to_destination: inbound_to,
            booking_date: dayjs(date).format("YYYY-MM-DD"),
        });
        inbound_rate = inbound;
    }
    const rates = {
        outbound: vehicle_id
            ? outbound_rate.filter((x) => x.vehicle_id === vehicle_id)
            : outbound_rate,
        inbound: type === "CUSTOM"
            ? vehicle_id
                ? inbound_rate.filter((x) => x.vehicle_id === vehicle_id)
                : inbound_rate
            : vehicle_id
                ? outbound_rate.filter((x) => x.vehicle_id === vehicle_id)
                : outbound_rate,
    };
    return rates;
};
exports.loadTransferRates = loadTransferRates;
